import { FunctionComponent } from 'react';
import { ErrorMessage } from 'formik';

import { TypeGroupFormProps } from './types';

export const GroupForm: FunctionComponent<TypeGroupFormProps> = ({
  children,
  name,
  className = '',
}: TypeGroupFormProps) => (
  <div
    className={`flex flex-col gap-2 ${className}`}
    role="group"
    aria-labelledby={name}
  >
    {children}

    <ErrorMessage name={name}>
      {(msg) => (
        <div className="text-tertiary-500 text-body text-body--s">{msg}</div>
      )}
    </ErrorMessage>
  </div>
);
